/* eslint-disable @stencil-community/required-jsdoc */
import { Component, Host, h, Prop } from '@stencil/core';
import { Memoize, parseIfString } from '@springbokagency/stencil-base';
import type { Components } from '../../../index';

interface EfbImg extends Components.EfbImg {}

@Component({
  tag: 'efb-video-block',
  styleUrl: 'video-block.scss',
  shadow: true,
})
export class EfbVideoBlock {
  /**
   * Props
   */

  @Prop() image: EfbImg | string;

  @Memoize('image')
  get parsedImage(): EfbImg {
    return parseIfString(this.image);
  }

  @Prop() ratio?: 'square' | 'landscape' | 'portrait' = 'portrait';

  @Prop() videoId: string;

  @Prop() videoGroupId: string;

  @Prop() dataAnalytics: string;

  @Prop() heading?: string;

  @Prop() text?: string;

  @Prop() size?: 'default' | 'standout' | 'thumbnail' = 'default';

  render() {
    return (
      <Host>
        <div class={`video-block is-${this.size}-size`}>
          {/* Video thumbnail */}
          <efb-click-action
            tagClass={`video-thumbnail has-${this.ratio}-ratio`}
            name="open-video-modal"
            value={{
              videoGroupId: this.videoGroupId,
              videoId: this.videoId,
            }}
            dataAnalytics={this.dataAnalytics}
          >
            {/* Image */}
            <efb-img {...this.parsedImage} cover />

            {/* Play button */}
            <efb-icon class="play-button" name="play-circle" />
          </efb-click-action>

          {/* Text */}
          {(this.heading || this.text) && (
            <div class="text-wrapper">
              {this.heading && <h3 class="title" innerHTML={this.heading}></h3>}

              {this.text && <p class="text" innerHTML={this.text}></p>}
            </div>
          )}
        </div>
      </Host>
    );
  }
}
